import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import Lenis from "lenis";
import "@/App.css";
import Layout, { ScrollManager } from "@/components/Layout";
import Home from "@/pages/Home";
import ServicePage from "@/pages/ServicePage";
import AreaPage from "@/pages/AreaPage";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import NotFound from "@/pages/NotFound";
import { SERVICES } from "@/data/services";
import { AREAS } from "@/data/areas";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }
  static getDerivedStateFromError(error) {
    return { error };
  }
  render() {
    if (this.state.error) {
      return (
        <div className="min-h-screen bg-ink flex items-center justify-center p-6" dir="rtl">
          <div className="text-center max-w-md">
            <h1 className="font-display font-black text-2xl text-white mb-3">حدث خطأ غير متوقع</h1>
            <p className="text-gray-400 text-sm mb-6">
              يمكنك التواصل معنا عبر واتساب: 0538644740 — بنشر متنقل نجم الإطار، الرياض 24 ساعة.
            </p>
            <button
              onClick={() => window.location.reload()}
              className="bg-gold text-ink font-extrabold rounded-full px-6 py-3"
              data-testid="error-reload-btn"
            >
              إعادة تحميل الصفحة
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default function App() {
  useEffect(() => {
    const gaId = process.env.REACT_APP_GA_ID;
    if (gaId && !window.GA_INITIALIZED) {
      window.GA_INITIALIZED = true;
      const s = document.createElement("script");
      s.async = true;
      s.src = `https://www.googletagmanager.com/gtag/js?id=${gaId}`;
      document.head.appendChild(s);
      window.dataLayer = window.dataLayer || [];
      const gtag = (...args) => window.dataLayer.push(args);
      window.gtag = gtag;
      gtag("js", new Date());
      gtag("config", gaId);
    }
  }, []);

  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return undefined;
    const lenis = new Lenis({ duration: 1.05, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <ErrorBoundary>
      <HelmetProvider>
        <BrowserRouter>
          <ScrollManager />
          <Layout>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/المتجر" element={<Navigate to="/" replace />} />
              <Route path="/طلب-بنشر" element={<Navigate to="/" replace />} />
              <Route path="/المدونة" element={<Blog />} />
              <Route path="/المدونة/:slug" element={<BlogPost />} />
              {SERVICES.map((s) => (
                <Route key={s.slug} path={`/${s.slug}`} element={<ServicePage service={s} />} />
              ))}
              {AREAS.map((a) => (
                <Route key={a.slug} path={`/${a.slug}`} element={<AreaPage area={a} />} />
              ))}
              <Route path="*" element={<NotFound />} />
            </Routes>
          </Layout>
        </BrowserRouter>
      </HelmetProvider>
    </ErrorBoundary>
  );
}
